module.exports = __webpack_public_path__ + "static/media/logo_green.c371cd74.svg";